import React from 'react';

import {observer} from "mobx-react";
import {ScoresListHeaderModuleProps} from "../../models/scores-list-header-module.props";
import {HeaderDateSelector} from "../../../../core/components/date-selector/header-date.selector";

export const ScoresListHeaderModuleDesktopDater = observer(({controller, toRenderCalendar, prevTooltip, nextTooltip, nextLinkModel, previousLinkModel, onClickPrevious, onClickNext, linkType, onDateChange}: ScoresListHeaderModuleProps) => {
  const {state} = controller;
  const {terms, device, startDate, endDate} = state;
  const headerDaterProps = {
    toRenderCalendar: toRenderCalendar,
    i18n: terms,
    device: device,
    date: startDate,
    endDate: endDate,
    prevTooltip: prevTooltip,
    nextTooltip: nextTooltip,
    nextLinkModel: nextLinkModel,
    previousLinkModel: previousLinkModel,
    onClickPrevious: () => onClickPrevious && onClickPrevious(),
    onClickNext: () => onClickNext && onClickNext(),
    linkType: linkType,
    controller: controller,
    onCalendarDateChange: onDateChange
  };

  return (
    <HeaderDateSelector {...headerDaterProps} />
  )
});
